import * as Types from "../constants/InitFormConstants";

// FETCH RECORDS ACTIONS
export const fetchRecords = () => ({
    type: Types.FETCH_RECORDS
});

export const fetchRecordsOk = (records) => ({
    type: Types.FETCH_RECORDS_OK,
    payload: records
})

export const fetchRecordsFailed = (error) => ({
    type: Types.FETCH_RECORDS_FAILED,
    payload: error
})